import { render, staticRenderFns } from "./CompomentTooltip.vue?vue&type=template&id=cf9f4990&scoped=true&"
import script from "./CompomentTooltip.vue?vue&type=script&lang=js&"
export * from "./CompomentTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CompomentTooltip.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompomentTooltip.vue?vue&type=style&index=1&id=cf9f4990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f4990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
